export default __webpack_public_path__ + "static/media/marker_blue.01a2a447.svg";